import { render, staticRenderFns } from "./DeliveryAddress.vue?vue&type=template&id=3aca618b&scoped=true"
import script from "./DeliveryAddress.vue?vue&type=script&lang=js"
export * from "./DeliveryAddress.vue?vue&type=script&lang=js"
import style0 from "./DeliveryAddress.vue?vue&type=style&index=0&id=3aca618b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aca618b",
  null
  
)

export default component.exports